import { formatCurrency } from '../../../../../utils/formatUtils';
import FormInfo from '../../../../components/messages/FormInfo';
import { COLineDraft } from '../../../../Interfaces/Accounting/ACForms.interfaces';
import COPhaseSummary from './COPhaseSummary';

type COLineSummaryProps = {
  line: COLineDraft;
  item: number;
};

const COLineSummary = ({ line, item }: COLineSummaryProps) => {
  const phases = line.phases?.filter((phase) => !!phase.code) ?? [];

  return (
    <div className="grid avoid-break mx-0 mb-2 mt-1">
      <div className="col-12 sm:col-6 py-1">
        <FormInfo label="SOV Item #" content={item} />
      </div>
      <div className="col-12 sm:col-6 py-1">
        <FormInfo label="Description" content={line.description} />
      </div>
      <div className="col-12 sm:col-6 py-1">
        <FormInfo
          label="Item Amount"
          content={formatCurrency(line.amount as number)}
        />
      </div>
      {phases.length > 0 && (
        <div className="col-12 pt-1">
          <FormInfo label="Job Cost Phases" content="" />
          {phases.map((phase, index) => {
            return (
              <COPhaseSummary
                phase={phase}
                key={`${item}-${index}-${phase.code}`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default COLineSummary;
